<template>
  <div class="chart-box">
    <div class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/radar'

export default {
  props: {
    rows: {
      type: Array,
      default () {
        return []
      }
    }
  },
  mounted () {
    // 初始化
    this.init()
  },
  methods: {
    // 初始化
    init () {
      const el = document.querySelector('.chart-container')
      const chart = echarts.init(el)
      const indicator = this.rows.map(item => {
        const { name, sum } = item
        return { name, max: sum }
      })
      const dataValue = this.rows.map(item => item.score)
      chart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0)',
        radar: {
          name: {
            textStyle: {
              color: '#c4fff7',
              borderRadius: 3,
              fontSize: 15
            }
          },
          radius: 65,
          center: ['50%', '50%'],
          indicator: indicator
        },
        series: [{
          type: 'radar',
          symbol: 'none',
          lineStyle: {
            normal: {
              width: 5,
              opacity: 0.5
            }
          },
          itemStyle: {
            normal: {
              lineStyle: {
                color: '#c4fff7'
              },
              areaStyle: {
                color: 'rgba(219, 230, 255, 0.6)'
              }
            }
          },
          data: [
            {
              value: dataValue
            }
          ]
        }]
      })
      chart.on('finished', () => {
        this.$emit('finished', true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-box {
  text-align: center;
  .chart-container {
    display: inline-block;
    height: 194px;
    text-align: center;
    width: 289px;
  }
}
</style>
